const appInfo = {
    title: 'MarketIA'
};
export default appInfo;

